// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_9mTtL","p1":"index_p1_O4kgx","p2":"index_p2_2us0T"};